
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const designinlayoutApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listDesignInLayouts: builder.query ({
      query: (params) => `v2/designinlayout/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["DesignInLayout"]
    }),
    getDesignInLayout: builder.query ({
      query: (designinlayout_id) => `v2/designinlayout/${designinlayout_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["DesignInLayout"]
    }),

    updateDesignInLayout: builder.mutation ({
      query: ({designinlayout_id, data}) => ({
        url: `v2/designinlayout/${designinlayout_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["DesignInLayout"]
    }),
    deleteDesignInLayout: builder.mutation ({
      query: (designinlayout_id) => ({
        url: `v2/designinlayout/${designinlayout_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["DesignInLayout"]
    }),
    createDesignInLayout: builder.mutation ({
      query: (data) => ({
        url: `v2/designinlayout/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["DesignInLayout"]
    }),
  })
})


export const {
  useListDesignInLayoutsQuery,
  useLazyListDesignInLayoutsQuery,
  useGetDesignInLayoutQuery,
  useLazyGetDesignInLayoutQuery,

  useUpdateDesignInLayoutMutation,
  useDeleteDesignInLayoutMutation,
  useCreateDesignInLayoutMutation
} = designinlayoutApi
